import { postCall, getCall, putCall } from "./api";

// trips policy

export const createTripPolicy = async(input = {}) => {
    return await postCall({ path: `/policy`, bodyParams: input, });
};

export const getAllTripsPolicy = async(legalUnit) => {
    console.log(legalUnit);
    return await getCall({ path: `/policy/${legalUnit}?type=TRIP`, });
};

export const updateTripPolicy = async(policyId, input = {}) => {
    return await putCall({ path: `/policy/${policyId}`, bodyParams: input, });
};

// add approver to policy

export const addApprovers = async(policyId, input = {}) => {
    return await putCall({ path: `/policy/${policyId}`, bodyParams: input, });
};


// vehicle type

export const createVehicleType = async(input = {}) => {
    return await postCall({ path: `/policy-cateogary`, bodyParams: input, });
};

export const getAllVehicleType = async(legalUnit) => {
    return await getCall({ path: `/policy-cateogary/${legalUnit}?type=TRIP`, });
};

export const getVehicleTypeById = async(id) => {
    return await getCall({ path: `/policy-cateogary/id/${id}`, });
};

export const updateVehicleType = async(id, input = {}) => {
    return await putCall({ path: `/policy-cateogary/${id}`, bodyParams: input });
};

// Get all trips of organisation

export const getAllTrips = async() => {
    return await getCall({ path: `/trip/v2/organization`, });
};

// Get trip by trip id

export const getTripById = async(tripId) => {
    return await getCall({ path: `/trip/v2/${tripId}`, });
};

//Get all trips that have converted to expenses

export const getTrip = async(pageNumber, pageSize, date, department, employeeName) => {
    let queryParams = `?pageSize=${pageSize}&pageNumber=${pageNumber}`;

    if (date) {
        queryParams += `&date=${date}`;
    }
    if (department) {
        queryParams += `&department=${department}`;
    }
    if (employeeName) {
        queryParams += `&employeeName=${employeeName}`;
    }

    return await getCall({ path: `/expense/trip${queryParams}`, });
};

//get latest trip by employee id

export const getLatestTripByEmployeeId = async(empId) => {
    return await getCall({ path: `/trip/v2/latest/${empId}`, });
}